export default __webpack_public_path__ + "static/media/wPeople1.8404baf5.png";